(function (app, ng) {
    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Reports.New.FieldGridView",
                {
                    url: "/FieldGrid",
                    component: "fieldGridView"
                });
        }
    ]);

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Reports.Edit.FieldGridView",
                {
                    url: "/FieldGrid",
                    component: "fieldGridView"
                });
        }
    ]);

    app.component("fieldGridView",
        {
            templateUrl: "/App/Reports/EditReport/FieldGridView/field-grid-view.template.html",
            controller: fieldGridViewController,
            bindings: {
                activeCustomFields: "=",
                activeFields: "=",
                condition: "=",
                customConditions: "=",
                customFields: "=",
                fields: "=",
                searchText: "=",
                unsaved: "=",
                reportType: "="
            }
        });

    fieldGridViewController.$inject = ["_"];
    function fieldGridViewController(_) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                ui: {}
            });

        $ctrl.fieldFilter = field => {
            if (!$ctrl.searchText) return true;
            $ctrl.searchText = !!$ctrl.searchText ? $ctrl.searchText.toLowerCase() : '';
            if (field.DisplayName.toLowerCase().indexOf($ctrl.searchText) !== -1) return true;
            return false;
        };

        $ctrl.toggleField = field => {
            if (!field.Active) {
                _.remove($ctrl.activeFields,
                    function (row) {
                        return row.Name === field.Name;
                    });

                _.remove($ctrl.condition.parameters,
                    function (row) {
                        return row.parameters[0].parameter === field.Name || row.parameters[0].parameter === field.ConditionName ||
                            row.parameters[0].parameters && row.parameters[0].parameters[1].parameter === field.Name;
                    });
            } else {
                $ctrl.activeFields.push(field);
            }

            $ctrl.ui.selectAll = $ctrl.fields.length === $ctrl.activeFields.length;
            $ctrl.unsaved = true;
        };

        $ctrl.toggleCustomField = customField => {
            if (!customField.Active) {
                _.remove($ctrl.activeCustomFields,
                    function (row) {
                        return row.Id === customField.Id;
                    });

                _.remove($ctrl.customConditions,
                    function (row) {
                        return row.Parameter === customField.Id;
                    });
            } else {
                $ctrl.activeCustomFields.push(customField);
            }

            $ctrl.ui.selectAllCustomFields = $ctrl.customFields.length === $ctrl.activeCustomFields.length;
            $ctrl.unsaved = true;
        };

        $ctrl.selectAll = () => {
            $ctrl.activeFields = [];
            ng.forEach($ctrl.fields,
                (field) => {
                    field.Active = $ctrl.ui.selectAll;

                    if ($ctrl.ui.selectAll) {
                        $ctrl.activeFields.push(field);
                    }
                });

            $ctrl.unsaved = true;
        };

        $ctrl.selectAllCustomFields = () => {
            $ctrl.activeCustomFields = [];
            ng.forEach($ctrl.customFields,
                function (customField) {
                    customField.Active = $ctrl.ui.selectAllCustomFields;

                    if ($ctrl.ui.selectAllCustomFields) {
                        $ctrl.activeCustomFields.push(customField);
                    } else {
                        $ctrl.customConditions = [];
                    }
                });

            $ctrl.unsaved = true;
        };

        $ctrl.$onInit = () => {
            $ctrl.ui.selectAll = $ctrl.fields.length === $ctrl.activeFields.length;
            $ctrl.ui.selectAllCustomFields = !!$ctrl.activeCustomFields.length && $ctrl.activeCustomFields.length === $ctrl.customFields.length;
        };
    }

})(window.app, window.angular);